export default {"src":"/_next/static/media/friends-celebration.mono.71c5c1a3.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};